import React from 'react';
import { Stack, Text } from '@moda/om';
import { ProductDetailsFragment } from '../../generated/types/ProductDetailsFragment';

import './EditorsNote.scss';

interface Props {
  variant: ProductDetailsFragment;
}

export const EditorsNote: React.FC<Props> = ({ variant: { description } }) => {
  if (!description || description == '<p></p>\n') return null;

  return (
    <Stack className="EditorsNote" space={3}>
      <Text treatment="body1">EDITOR'S NOTE</Text>
      <Text dangerouslySetInnerHTML={{ __html: description || '' }} />
    </Stack>
  );
};
